module.exports = __webpack_public_path__ + "img/34.68d41fbd.png";